module.exports = __webpack_public_path__ + "static/media/NTSA.247a1994.png";